import { injectGlobal } from 'styled-components';

/* eslint no-unused-expressions: 0 */
injectGlobal`
  html,
  body {
    height: 100%;
    width: 100%;
    font-family: halyard-text, sans-serif;
    font-variant-numeric: lining-nums;
    -moz-font-feature-settings: "lnum";
    -webkit-font-feature-settings: "lnum";
    font-feature-settings: "lnum";
    margin: 0;
  }

  ::selection {
    color: #14143D;
  }

  input::-ms-clear, input::-ms-reveal {
    display: none;
  }

  #app {
    background-color: #FaFaFa;
    min-height: 100%;
    min-width: 100%;
    font-family: halyard-text, sans-serif;
  }

  label {
    font-weight: 500;
  }

  @font-face {
      font-family: halyard-text, sans-serif;
  }

  .tooltip {
    background-color: #5A5AAD !important;
    font-family: halyard-text, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    &.place-top {
      &:after {
        border-top-color: #5A5AAD !important;
      }
    }
  }

  /* Prevent the text contents of draggable elements from being selectable. */
  [draggable] {
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    /* Required to make elements draggable in old WebKit */
    -khtml-user-drag: element;
    -webkit-user-drag: element;
  }
`;
